import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { LiftErrorService } from './lift-error.service';
import { LiftErrorCriteria } from '../models/lift-error.criteria';

@Injectable({ providedIn: 'root' })
export class LiftErrorDashboardResolver implements Resolve<any> {
  constructor(
    private liftErrorService: LiftErrorService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    let params = new LiftErrorCriteria();
    params.pageSize = 5;

    return this.liftErrorService.getCompanyErrorsFromLastLogin(params.paramsExport());
  }
}
